export default {
    number : {
        'title' : 'Номер этажа',
        'mask'  : '{этаж: floor[number]}'
    }
}